import { render, staticRenderFns } from "./AppointmentDialog.vue?vue&type=template&id=40c38e22"
import script from "./AppointmentDialog.vue?vue&type=script&lang=js"
export * from "./AppointmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports